import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";
import { AdminAccountListItem } from "./useGetConsoleAdminAccounts";

export const useGetConsoleAdminAccount = (idx: number | string | undefined): UseQueryResult<AdminAccountListItem, Error> => {
    return useQuery({
        queryKey: ["useGetConsoleAdminAccount", idx],
        enabled: idx !== undefined && idx !== null && String(idx).length > 0,
        queryFn: async () => {
            const url = enum_api_uri.get_console_admin_account_detail.replace(":idx", String(idx));
            const response = await axiosInstance.get(url);
            return response.data.data;
        },
    });
};
